'use strict';

import uuid from 'uuid';

/**
 * @property {String}   id          - unique id of content block
 * @property {String}   body        - string content of content block, typically html
 * @property {String}   permissions - maps to users' role, restricts view ability to specific role. Note that this can-
                                      be overwritten by the lore permissions
 * @property {Boolean}  locked
 * @property {Date}     created
 * @property {Date}     modified
 */
export default class ContentBlock {
  /**
   * @param {String}  id
   * @param {String}  body
   * @param {String}  permissions
   * @param {Boolean} locked
   * @param {Date}    created
   * @param {Date}    modified
   */
  constructor(id, body, permissions, locked, created, modified) {
    this.id = id || uuid.v4();
    this.body = body || null;
    this.permissions = permissions || 'gm';
    this.locked = locked || false;
    this.created = created || new Date();
    this.modified = modified || new Date();
  }
}